import Badge from '../../components/Badge';

type Variant = 'success' | 'warning' | 'error' | 'info' | 'neutral';

const VARIANTS: Record<string, [Variant, string]> = {
  active: ['success', 'Active'],
  revoked: ['neutral', 'Revoked'],
  superseded: ['info', 'Replaced'],
  expired: ['neutral', 'Expired'],
  'bank-suspended': ['error', 'Stopped by bank'],
  proposed: ['warning', 'Waiting for you'],
  consented: ['success', 'Accepted'],
  declined: ['neutral', 'Declined'],
  withdrawn: ['neutral', 'Withdrawn'],
  SUBMITTED: ['warning', 'Awaiting bank'],
  PENDING_HUMAN: ['warning', 'Needs approval'],
  AUTHORISED: ['success', 'Paid'],
  DECLINED: ['error', 'Declined'],
  EXPIRED: ['neutral', 'Not sent'],
};

/** A mandate, proposal or payment status in words a customer reads. */
export default function UPIStatusBadge({ status, label }: { status: string; label?: string }) {
  const [variant, text] = VARIANTS[status] ?? ['neutral', status];
  return <Badge variant={variant} pulse={status === 'PENDING_HUMAN' || status === 'SUBMITTED'}>{label ?? text}</Badge>;
}
